<h3>Manuale d'utilizzo</h3>
<br/>
<div class="container mt-3">
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (2).png" alt="Zoom" class="img-fluid">
    </div>
    <div class="col-9">
        <p>I pulsanti consentono di ingrandire/ridurre la mappa</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (3).png" alt="Seleziona layer" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Il pulsante permette di aprire il menu per la scelta della mappa da visualizzare</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (7).png" alt="Seleziona layer mappa" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Seleziona la mappa preferita</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (8).png" alt="Tipologia di servizi" class="img-fluid">
    </div>
    <div class="col-9">
        <p>È possibile visualizzare su mappa sia i Servizi educativi per l’infanzia regionali che le Strutture socio assistenziali regionali, selezionando il rispettivo ambito di interesse</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (9).png" alt="Filtri di ricerca" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Indicando anche parzialmente la denominazione è possibile ricercare una specifica struttura/servizio educativo</p>
        <p>Indicando la provincia si ricercano tutte le strutture/servizi educativi della provincia</p>
        <p>Indicando il comune si ricercano tutte le strutture/servizi educativi del comune</p>
        <p>Indicando anche parzialmente l’indirizzo o inserendo il CAP è possibile limitare ulteriormente la ricerca</p>
        <p>Selezionando Il Distretto socio-sanitario si limita la ricerca alle strutture del Distretto</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (10).png" alt="Pulsante Azzera" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Questo pulsante consente di cancellare i criteri di ricerca precedentemente inseriti</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (11).png" alt="Pulsante Cerca" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Questo pulsante avvia la ricerca con i criteri selezionati</p>
    </div>
  </div>
  <div *ngIf="appUrlFilter !== 'assa'" class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (4).png" alt="Segnaposto Rosso" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Servizi educativi per l'infanzia Privati</p>
    </div>
  </div>
  <div *ngIf="appUrlFilter !== 'assa'" class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (5).png" alt="Segnaposto Blu" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Servizi educativi per l'infanzia Pubblici</p>
    </div>
  </div>
  <div *ngIf="appUrlFilter !== 'sirse'" class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (6).png" alt="Segnaposto Verde" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Strutture Socio-Assistenziali</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (13).png" alt="Cluster di zona" class="img-fluid">
    </div>
    <div class="col-9">
        <p>{{appUrlFilter === 'assa' ? 'Strutture' : 'Servizi'}} nell'area</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (12).png" alt="Strumenti di paginazione" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Indicazione dei risultati visualizzati nella lista</p>
    </div>
  </div>
  <div class="row align-items-center justify-content-center">
    <div class="col-3 text-end">
        <img src="assets/images/tutorial/tutorial (1).png" alt="Esporta i risultati di ricerca" class="img-fluid">
    </div>
    <div class="col-9">
        <p>Il pulsante consente di esportare tutti i risultati della ricerca in un documento formato PDF</p>
    </div>
  </div>
</div>
